import emoji from 'markdown-it-emoji';
import bare from 'markdown-it-emoji/bare.js';
import light from 'markdown-it-emoji/light.js';

export default emoji;

export {bare, light};
